import { useEffect, useState } from "react";
import Select from "react-select";
import httpRequest from "../../../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./CompanyBasicDetails.css";

const CompanyBasicDetails = ({
  partnerDetails,
  setPartnerDetails,
  role_id,
}) => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const getCompanyType = [
    { value: "Individual", label: "Individual" },
    { value: "Proprietorship Firm", label: "Proprietorship Firm" },
    { value: "Partnership Firm", label: "Partnership Firm" },
    { value: "Private Ltd Company", label: "Private Ltd Company" },
    { value: "Public Ltd Company", label: "Public Ltd Company" },
  ];

  const [isSubmit, setSubmit] = useState(false);
  const [stateOption, setStateOption] = useState([]);
  const [stateValue, setstateValue] = useState(null);
  const [cityOption, setCityOption] = useState([]);
  const [cityValue, setCityValue] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [ctypeValue, setCtypeValue] = useState({});

  useEffect(() => {
    if (partnerDetails && Object.keys(partnerDetails).length > 0) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        company_name: partnerDetails.company_name,
        partner_id: partnerDetails.partner_id,
        display_name: partnerDetails.display_name,
        company_type: partnerDetails.company_type,
        pincode: partnerDetails.pincode,
        state_id: partnerDetails.state_id,
        city: partnerDetails.city,
        company_address: partnerDetails.company_address,
      }));

      setCtypeValue(
        getCompanyType.find((x) => x.value === partnerDetails.company_type),
      );

      getAllCity(partnerDetails.pincode);
    }
  }, [partnerDetails]);

  const validateFrom = (value) => {
    const errors = {};
    //console.log(value);
    if (!value.company_name) {
      errors.company_name = "Company Name is Required";
    }

    if (!value.display_name) {
      errors.display_name = "Display Name is Required";
    }
    if (!value.company_type) {
      errors.company_type = "Company Type is Required";
    }
    // Check if pincode is provided
    if (!value.pincode) {
      errors.pincode = "Pincode is Required";
    } else {
      // Check if pincode is a 6-digit number
      const pincodePattern = /^[0-9]{6}$/;
      if (!pincodePattern.test(value.pincode)) {
        errors.pincode = "Pincode must be a 6-digit number";
      }
    }

    if (!value.state_id) {
      errors.state_id = "State is Required";
    }

    if (!value.city) {
      errors.city = "City is Required";
    }
    if (!value.company_address) {
      errors.company_address = "Company Address is Required";
    }

    // if (
    //   value.pan_number == partnerDetails.pan_number &&
    //   value.gst_number == partnerDetails.gst_details.gst_number &&
    //   !value.pan_file &&
    //   !value.gst_file
    // ) {
    //   errors.mandatory = "There is no change in the existing data.";
    // }
    //console.log(errors);
    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setSubmit(false);
    setFormErrors(validateFrom(formData));
    setSubmit(true);
  };
  const getAllCity = (pincode) => {
    if (pincode) {
      (async () => {
        try {
          setStateOption([]);
          setstateValue(null);
          setCityOption([]);
          setCityValue(null);

          const listdata = await httpRequest(
            "getallcity?pincode=" + pincode,
            {},
            "GET",
          );

          console.log("API Response:", listdata); // Log API response

          if (listdata.status === true && listdata.message) {
            const state = listdata.message[0]?.state;
            if (state) {
              console.log("State ID:", state.id);

              setStateOption([state]);
              setFormData((prevFormData) => ({
                ...prevFormData,
                state_id: state.id,
                pincode,
              }));
              setstateValue(state);
              setCityOption(listdata.message);

              const selectedValue = listdata.message.find(
                (x) => x.value === partnerDetails.city,
              );
              setCityValue(selectedValue);
              console.log("Selected City:", selectedValue);
            }
          }
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      })();
    }
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        const data = await httpRequest(
          "addupdatecompanybasicdetails",
          formData,
          "POST",
        );
        setSubmit(false);
        if (data.status === true && data.message) {
          toast.success(data.message);
          document.getElementById("basicDetailsform").reset();

          if (!formData.partner_id) {
            navigate(`/updatepartner/${data.data.partner_id}`);
          }

          setPartnerDetails(data.data);
        } else {
          toast.error(data.message);
        }
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  return (
    <div className="company-basic-details-container">
      <form
        className="company-basic-form"
        id="basicDetailsform"
        onSubmit={onSubmitHandler}
      >
        {/* Section 1: Company Information */}
        <div className="form-section">
          <div className="section-header">
            <h5>Company Information</h5>
            <div className="section-divider"></div>
          </div>

          <div className="form-grid">
            {/* Company Name */}
            <div className="form-field">
              <label className="field-label">
                Company Name <span className="required-mark">*</span>
              </label>
              <input
                type="text"
                className={`form-input ${formErrors.company_name ? "input-error" : ""}`}
                id="company_name"
                placeholder="Enter company name"
                name="company_name"
                defaultValue={partnerDetails.company_name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    company_name: e.target.value,
                  });
                }}
              />
              {formErrors.company_name && (
                <span className="error-message">{formErrors.company_name}</span>
              )}
            </div>

            {/* Display Name */}
            <div className="form-field">
              <label className="field-label">
                Display Name <span className="required-mark">*</span>
              </label>
              <input
                type="text"
                className={`form-input ${formErrors.display_name ? "input-error" : ""}`}
                id="display_name"
                name="display_name"
                placeholder="Enter display name"
                defaultValue={partnerDetails.display_name}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    display_name: e.target.value,
                  });
                }}
              />
              {formErrors.display_name && (
                <span className="error-message">{formErrors.display_name}</span>
              )}
            </div>

            {/* Company Type */}
            <div className="form-field">
              <label className="field-label">
                Company Type <span className="required-mark">*</span>
              </label>
              <Select
                classNamePrefix="company-select"
                name="company_type"
                value={ctypeValue}
                options={getCompanyType}
                placeholder="Select company type"
                onChange={(val) => {
                  setFormData({ ...formData, company_type: val.value });
                  setCtypeValue(val);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "8px",
                    borderColor: formErrors.company_type
                      ? "#e74c3c"
                      : "#d7e3ee",
                    backgroundColor: "#fff",
                  }),
                }}
              />
              {formErrors.company_type && (
                <span className="error-message">{formErrors.company_type}</span>
              )}
            </div>
          </div>
        </div>

        {/* Section 2: Location Details */}
        <div className="form-section">
          <div className="section-header">
            <h5>Location Details</h5>
            <div className="section-divider"></div>
          </div>

          <div className="form-grid">
            {/* Pincode */}
            <div className="form-field">
              <label className="field-label">
                Pincode <span className="required-mark">*</span>
              </label>
              <input
                type="text"
                id="pincode"
                name="pincode"
                className={`form-input ${formErrors.pincode ? "input-error" : ""}`}
                placeholder="Enter 6-digit pincode"
                defaultValue={partnerDetails.pincode}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    pincode: e.target.value,
                  });
                  getAllCity(e.target.value);
                }}
              />
              {formErrors.pincode && (
                <span className="error-message">{formErrors.pincode}</span>
              )}
            </div>

            {/* State */}
            <div className="form-field">
              <label className="field-label">
                State <span className="required-mark">*</span>
              </label>
              {formData.pincode && stateValue === null && (
                <div className="loading-state">Loading state...</div>
              )}
              <Select
                classNamePrefix="company-select"
                name="state"
                value={stateValue}
                options={stateOption}
                placeholder="Select state"
                onChange={(val) => {
                  setFormData({ ...formData, state_id: val.value });
                  setstateValue(val);
                }}
                isDisabled={!formData.pincode}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "8px",
                    borderColor: formErrors.state_id ? "#e74c3c" : "#d7e3ee",
                    backgroundColor: !formData.pincode ? "#f5f5f5" : "#fff",
                  }),
                }}
              />
              {formErrors.state_id && (
                <span className="error-message">{formErrors.state_id}</span>
              )}
            </div>

            {/* City */}
            <div className="form-field">
              <label className="field-label">
                City <span className="required-mark">*</span>
              </label>
              {formData.pincode && cityValue === null && (
                <div className="loading-state">Loading cities...</div>
              )}
              <Select
                classNamePrefix="company-select"
                name="city"
                placeholder="Select city"
                value={cityValue}
                options={cityOption}
                onChange={(val) => {
                  setFormData({ ...formData, city: val.value });
                  setCityValue(val);
                }}
                isDisabled={!formData.pincode}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "42px",
                    borderRadius: "8px",
                    borderColor: formErrors.city ? "#e74c3c" : "#d7e3ee",
                    backgroundColor: !formData.pincode ? "#f5f5f5" : "#fff",
                  }),
                }}
              />
              {formErrors.city && (
                <span className="error-message">{formErrors.city}</span>
              )}
            </div>
          </div>
        </div>

        {/* Section 3: Address */}
        <div className="form-section">
          <div className="section-header">
            <h5>Address Information</h5>
            <div className="section-divider"></div>
          </div>

          <div className="form-grid form-grid-full">
            <div className="form-field">
              <label className="field-label">
                Address <span className="required-mark">*</span>
              </label>
              <textarea
                className={`form-input form-textarea ${formErrors.company_address ? "input-error" : ""}`}
                id="company_address"
                placeholder="Enter complete address"
                name="company_address"
                rows="4"
                defaultValue={partnerDetails.company_address}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    company_address: e.target.value,
                  });
                }}
              ></textarea>
              {formErrors.company_address && (
                <span className="error-message">
                  {formErrors.company_address}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Submit Button */}
        {role_id == 1 && (
          <div className="form-actions">
            <button type="submit" className="btn-submit">
              <i className="fas fa-save"></i> Save Changes
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default CompanyBasicDetails;
